import { render, staticRenderFns } from "./Buss.vue?vue&type=template&id=6e535de5&scoped=true"
import script from "./Buss.vue?vue&type=script&lang=js"
export * from "./Buss.vue?vue&type=script&lang=js"
import style0 from "./Buss.vue?vue&type=style&index=0&id=6e535de5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e535de5",
  null
  
)

export default component.exports